import React, { useState } from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import NoticeCard from "./NoticeCard";
import { Button, Col, notification, Popover, Row, Spin } from "antd";
import StopConfirmationContent from "./StopConfirmationContent";
import BinApiService from "src/api/BinApiService";

interface GrainMovingOperationsCardProps{
    binDto: PremierPlusBinDTO | null;
    handleClickViewGrainMoving: () => void;
}

const GrainMovingOperationsCard : React.FC<GrainMovingOperationsCardProps> = ({ binDto, handleClickViewGrainMoving }) => {
    const [isSpinning, setIsSpinning] = useState(false);
    const [augerPopoverOpen, setAugerPopoverOpen] = useState(false);

    const onClickYesStopAugers = async () => {
        try{
            setIsSpinning(true);
            await BinApiService.premierPlus_StopTransferingGrain(binDto?.binId ?? 0, false);
            notification.success({ message: 'Augers stopped successfully' });
            setAugerPopoverOpen(false);
        }catch(err){
            console.error('Error stopping augers:', err);
            notification.error({ message: 'Error stopping augers', description: 'Please try again later.' });
        }finally{
            setIsSpinning(false);
        }
    }

    const onClickNoStopAugers = () => {
        setAugerPopoverOpen(false);
    };

    return(
        <NoticeCard
        title="Move grain is active"
        description={`Grain is currently moving to ${binDto?.grainMovingOperation?.targetStorageBin?.name}`}
        buttons={
            <>
                <Popover
                    open={augerPopoverOpen}
                    trigger="click"
                    onOpenChange={(newOpen) => {
                    if (!newOpen) setAugerPopoverOpen(false);
                    }}
                    content={
                        <Spin spinning={isSpinning}>
                            <StopConfirmationContent
                            message="Are you sure you want to stop all augers?"
                            onConfirm={onClickYesStopAugers}
                            onCancel={onClickNoStopAugers}
                            />
                        </Spin>
                    }
                >
                    <Row justify={'center'} gutter={8}>
                        <Col>
                            <Button type="primary" danger onClick={() => setAugerPopoverOpen(true)}>
                            Stop All Augers
                            </Button>
                        </Col>

                        <Col>
                            <Button type="primary" onClick={handleClickViewGrainMoving}>
                            View HMI 
                            </Button> 
                        </Col>
                    </Row>
                </Popover>
            </>
        }
        />
    )
}

export default GrainMovingOperationsCard;